import { z } from 'zod';

import type { FieldConfig } from '@/types/forms';
import { createEnquirySchema } from '@/lib/forms/schemas/enquirySchema';

export const dentalEnquirySchema = createEnquirySchema({});

export type DentalEnquiryValues = z.infer<typeof dentalEnquirySchema>;

export const dentalEnquiryDefaultValues: DentalEnquiryValues = {
  fullName: '',
  email: '',
  phone: '',
  preferredContact: 'phone',
  message: '',
};

export const dentalEnquiryFields: FieldConfig[] = [
  {
    name: 'fullName',
    type: 'text',
    label: 'Full Name',
    placeholder: 'Enter your full name',
    required: true,
  },
  {
    name: 'email',
    type: 'email',
    label: 'Email Address',
    placeholder: 'Enter your email address',
    required: true,
  },
  {
    name: 'phone',
    type: 'tel',
    label: 'Phone Number',
    placeholder: 'Enter your phone number',
    required: true,
  },
  {
    name: 'preferredContact',
    type: 'radio',
    label: 'Preferred Contact Method',
    required: true,
    options: [
      { label: 'Phone', value: 'phone' },
      { label: 'Email', value: 'email' },
      { label: 'WhatsApp', value: 'whatsapp' },
    ],
    fullWidth: true,
  },
  {
    name: 'message',
    type: 'textarea',
    label: 'Message',
    placeholder: 'How can we help?',
    required: true,
    rows: 5,
    fullWidth: true,
  },
];
